import api from '../core/api';
import { ApiResponse } from '../core';
import VwStkdepotalepbaslikDTO from 'src/models/StokEczane/DepoTalepleri/VwStkdepotalepbaslikDTO';
import VwStkdepotalepdetayDTO from 'src/models/StokEczane/DepoTalepleri/VwStkdepotalepdetayDTO';
import VwYetkiliKullaniciDepolariDTO from 'src/models/StokEczane/DepoTalepleri/VwYetkiliKullaniciDepolariDTO';

const controllerName = 'DepoTalep';
export const DepoTalepApi = api.injectEndpoints({
  endpoints: (builder) => ({
    GetDepoTalepList: builder.query<Array<VwStkdepotalepbaslikDTO>, { basTarih: string, bitTarih: string, islemDurum: Array<number>, depoTanimId: number, talepDepoTanimID: number}>({
      query: (req) => ({
        url: controllerName + '/GetDepoTalepList',
        method: 'POST',
        body: JSON.stringify(req.islemDurum),
        params: { basTarih: req.basTarih, bitTarih: req.bitTarih, depoTanimId: req.depoTanimId, talepDepoTanimId: req.talepDepoTanimID, islemDurum: req.islemDurum }
      }),
    }),

    GetDepoTalepDetayList: builder.query<Array<VwStkdepotalepdetayDTO>, { basikId: number}>({
      query: (req) => ({
        url: controllerName + '/GetDepoTalepDetayList',
        method: 'GET',
        params: { baslikId: req.basikId}
      }),
      providesTags: ["DepoTalepDetayList"]      
    }),

    DepoTalepKabulEt: builder.mutation<ApiResponse<Boolean>, {
      talepDetayList: Array<VwStkdepotalepdetayDTO>, 
      orgId: number, teslimEdenPerId: number, onaylayanPerId: number, onaylanKullaniciId: number, gonderenDepoId: number
    }>(
      {
        query: (req) => ({
          url: controllerName + '/DepoTalepKabulEt',
          method: 'PUT',
          body: JSON.stringify(req.talepDetayList),
          params: {
            orgId: req.orgId,
            teslimEdenPerId: req.teslimEdenPerId,
            onaylayanPerId: req.onaylayanPerId,
            onaylanKullaniciId: req.onaylanKullaniciId,
            gonderenDepoId : req.gonderenDepoId
          } 
        })
      }
    ),

    DepoTalepEkle: builder.mutation<ApiResponse<VwStkdepotalepbaslikDTO>, VwStkdepotalepbaslikDTO>(
      {
        query: (req) => ({
          url: controllerName + '/DepoTalepEkle',
          method: 'POST',
          body: JSON.stringify(req),
        })
      }
    ),

    DepoTalepGuncelle: builder.mutation<ApiResponse<VwStkdepotalepbaslikDTO>, VwStkdepotalepbaslikDTO>(
      {
        query: (req) => ({
          url: controllerName + '/DepoTalepGuncelle',
          method: 'PUT',
          body: JSON.stringify(req),
        })
      }
    ),

    DepoTalepIptal: builder.mutation<ApiResponse<VwStkdepotalepbaslikDTO>, {id: number, iptalNedenId: number}>(
      {
        query: (req) => ({
          url: controllerName + '/DepoTalepIptal',
          method: 'DELETE',
          params: {
            id: req.id,
            iptalNedenId: req.iptalNedenId
          },
        })
      }
    ),

    DepoTalepDetayEkle: builder.mutation<ApiResponse<VwStkdepotalepdetayDTO>, VwStkdepotalepdetayDTO>(
      {
        query: (req) => ({
          url: controllerName + '/DepoTalepDetayEkle',
          method: 'POST',
          body: JSON.stringify(req),
        })
      }
    ),

    DepoTalepDetayGuncelle: builder.mutation<ApiResponse<VwStkdepotalepdetayDTO>, VwStkdepotalepdetayDTO>(
      {
        query: (req) => ({
          url: controllerName + '/DepoTalepDetayGuncelle',
          method: 'PUT',
          body: JSON.stringify(req),
        })
      }
    ),

    DepoTalepDetaySil: builder.mutation<ApiResponse<VwStkdepotalepbaslikDTO>, number>(
      {
        query: (id) => ({
          url: controllerName + '/DepoTalepDetaySil/',
          method: 'DELETE',
          params:{
            id: id
          }
        })
      }
    ),
    YetkiliKullaniciDepolariGetir: builder.query<Array<VwYetkiliKullaniciDepolariDTO>, {servisTanimIdList: Array<number>, depoTip : string}>(
      {
        query: (req) => ({
          url: controllerName + '/YetkiliKullaniciDepolariGetir',
          method: 'POST',
          body: JSON.stringify(req.servisTanimIdList),
          params: {depoTip :  req.depoTip}
        })
      }
    ),

  })
});

export const {
  useGetDepoTalepListQuery,
  useGetDepoTalepDetayListQuery,
  useDepoTalepKabulEtMutation,
  useDepoTalepEkleMutation,
  useDepoTalepGuncelleMutation,
  useDepoTalepIptalMutation,
  useDepoTalepDetayEkleMutation,
  useDepoTalepDetayGuncelleMutation,
  useDepoTalepDetaySilMutation,
  useLazyYetkiliKullaniciDepolariGetirQuery
} = DepoTalepApi;
